import React from "react";
import { Routes, Route } from "react-router-dom";
import { BasketProvider } from './context/BasketContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './screens/Home/Home';
import EventAvailability from './screens/EventAvailability/EventAvailability';
import BasketConfirmation from './screens/BasketConfirmation/BasketConfirmation';
import EventVehicleAvailability from './screens/EventVehicleAvailability/EventVehicleAvailability';
import CustomerLogin from './screens/CustomerLogin/CustomerLogin';
import CustomerBookings from './screens/CustomerBookings/CustomerBookings';
import BookingConfirmation from './screens/BookingConfirmation/BookingConfirmation';
import AmbassadorLogin from "./screens/AmbassadorLogin/AmbassadorLogin";
import EventSelect from "./screens/EventSelect/EventSelect";
import Checkout from "./screens/Checkout/Checkout";
import EventVehicleList from "./screens/EventVehicleList/EventVehicleList";
import ScooterEventSelect from "./screens/ScooterEventSelect/ScooterEventSelect";
import ScooterTypeSelect from "./screens/ScooterTypeSelect/ScooterTypeSelect";
import ScooterVehicleList from "./screens/ScooterVehicleList/ScooterVehicleList";
import ScooterVehicleAvailability from "./screens/ScooterVehicleAvailability/ScooterVehicleAvailability";
import ScooterBasketConfirmation from "./screens/ScooterBasketConfirmation/ScooterBasketConfirmation";
import ScooterCheckout from "./screens/ScooterCheckout/ScooterCheckout";
import ScooterBookingConfirmation from "./screens/ScooterBookingConfirmation/ScooterBookingConfirmation";

function App() {
  return (
    <AuthProvider>
      <BasketProvider>
        <ScrollToTop />
        <Routes>
          {/* The ambassador login is the only page that doesn't require auth */}
          <Route path="/ambassador-login" element={<AmbassadorLogin />} />

          {/* Everything else sits behind the ambassador login */}
          <Route path="/customer-login" element={
            <ProtectedRoute>
              <CustomerLogin />
            </ProtectedRoute>
          } />
          <Route path="/" element={
            <ProtectedRoute fallback="blank">
              <Home />
            </ProtectedRoute>
          } />
          <Route path="/event-select" element={
            <ProtectedRoute>
              <EventSelect />
            </ProtectedRoute>
          } />
          <Route path="/event/:eventId/availability" element={
            <ProtectedRoute>
              <EventAvailability />
            </ProtectedRoute>
          } />
          <Route path="/event/:eventId/vehicle-list" element={
            <ProtectedRoute>
              <EventVehicleList />
            </ProtectedRoute>
          } />
          <Route path="/event/:eventId/vehicle/:vehicleId/availability" element={
            <ProtectedRoute>
              <EventVehicleAvailability />
            </ProtectedRoute>
          } />
          {/* Scooter booking flow is publicly accessible */}
          <Route path="/scooter-event-select" element={<ScooterEventSelect />} />
          <Route path="/scooter/event/:eventId/select-type" element={<ScooterTypeSelect />} />
          <Route path="/scooter/event/:eventId/:vehicleType/vehicles" element={<ScooterVehicleList />} />
          <Route path="/scooter/event/:eventId/:vehicleType/vehicle/:vehicleId/availability" element={<ScooterVehicleAvailability />} />
          <Route path="/scooter/event/:eventId/:vehicleType/vehicle/:vehicleId/details" element={<ScooterBasketConfirmation />} />
          <Route path="/scooter-checkout" element={<ScooterCheckout />} />
          <Route path="/scooter-booking-confirmation" element={<ScooterBookingConfirmation />} />
          <Route path="/basket-confirmation" element={
            <ProtectedRoute>
              <BasketConfirmation />
            </ProtectedRoute>
          } />
          <Route path="/booking-confirmation" element={
            <ProtectedRoute>
              <BookingConfirmation />
            </ProtectedRoute>
          } />
          <Route path="/checkout" element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          } />
          <Route path="/customer-bookings" element={
            <ProtectedRoute>
              <CustomerBookings />
            </ProtectedRoute>
          } />
        </Routes>
      </BasketProvider>
    </AuthProvider>
  );
}

export default App;
